import './src/vaadin-iconset.js';

export * from './src/vaadin-icon-svg.js';
export * from './src/vaadin-iconset.js';
